import React from 'react'

const WhatsappButton = () => {
    const phone = "393515483140";
    const text = encodeURIComponent("Hello! I would like some info.");
    const url = `https://wa.me/${phone}?text=${text}`;

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chatta su WhatsApp"
            style={{
                position: "fixed",
                right: 18,
                bottom: 18,
                width: 56,
                height: 56,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                zIndex: 9999,
                cursor: "pointer",
            }}
        >
            <i class="bi bi-whatsapp" style={{fontSize: "30px", color: "#25D366"}}></i>
        </a>
    )
}

export default WhatsappButton